"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkEntry = exports.ButtonWidgetLinkMenu = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontend/ContentTokens/Models/inputs/Types");
var Types_2 = require("Tokens/Types");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var Types_3 = require("@CommonFrontendBackend/Tokens/Types");
var TokenInput_1 = __importDefault(require("Project/QwilrEditor/Widgets/TokenMenu/TokenInput"));
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var ButtonWidgetLinkMenu_css_1 = require("./ButtonWidgetLinkMenu.css");
var CurrentView;
(function (CurrentView) {
    CurrentView[CurrentView["LinkEntry"] = 0] = "LinkEntry";
    CurrentView[CurrentView["TokenEntry"] = 1] = "TokenEntry";
})(CurrentView || (CurrentView = {}));
var ButtonWidgetLinkMenu = function (_a) {
    var href = _a.href, close = _a.close, updateLink = _a.updateLink, confirmToken = _a.confirmToken, removeToken = _a.removeToken;
    var _b = __read((0, react_1.useState)(initialState(href)), 2), menuState = _b[0], updateMenuState = _b[1];
    var tokensEnableState = (0, inversify_react_1.useInjection)("tokensEnableState");
    switch (menuState) {
        case CurrentView.LinkEntry:
            var currHref = typeof href === "string" ? href : "";
            return (react_1.default.createElement(exports.LinkEntry, { href: currHref, onConfirm: function (newHref) {
                    updateLink(newHref);
                    close();
                }, onCancel: function () { return close(); }, onRemoveLink: function () {
                    updateLink("");
                    close();
                }, openTokenSelect: function () { return updateMenuState(CurrentView.TokenEntry); }, areTokensEnabled: tokensEnableState !== Types_2.TokensEnableState.Disabled }));
        case CurrentView.TokenEntry:
            var currToken = typeof href !== "string" ? href : undefined;
            return (react_1.default.createElement(TokenEntry, { token: currToken, confirmToken: function (token) {
                    confirmToken(token);
                    close();
                }, removeToken: function () {
                    removeToken();
                    updateMenuState(CurrentView.LinkEntry);
                } }));
    }
};
exports.ButtonWidgetLinkMenu = ButtonWidgetLinkMenu;
var LinkEntry = function (_a) {
    var href = _a.href, onConfirm = _a.onConfirm, onCancel = _a.onCancel, onRemoveLink = _a.onRemoveLink, openTokenSelect = _a.openTokenSelect, areTokensEnabled = _a.areTokensEnabled;
    var _b = __read((0, react_1.useState)(false), 2), hasError = _b[0], updateHasError = _b[1];
    var _c = __read((0, react_1.useState)(href), 2), currHref = _c[0], updateCurrHref = _c[1];
    var onUserConfirm = function () {
        if (checkIsValidCurrHref()) {
            onConfirm((0, CorrectLink_1.default)(currHref));
        }
    };
    var checkIsValidCurrHref = function () {
        if (currHref != "" && !(0, URL_1.isURL)((0, CorrectLink_1.default)(currHref), true)) {
            updateHasError(true);
            return false;
        }
        else {
            updateHasError(false);
            return true;
        }
    };
    var onKeyUp = function (event) {
        switch (event.key) {
            case "Enter":
                event.preventDefault();
                onUserConfirm();
                break;
            case "Escape":
                event.preventDefault();
                onCancel();
                break;
        }
    };
    return (react_1.default.createElement("div", { className: ButtonWidgetLinkMenu_css_1.buttonWidgetLinkMenuStyle },
        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Link is not a valid URL", size: kaleidoscope_1.TooltipSize.Large, show: hasError },
            react_1.default.createElement("input", { className: ButtonWidgetLinkMenu_css_1.buttonWidgetLinkInputStyle, type: "text", value: currHref, onChange: function (event) { return updateCurrHref(event.target.value); }, placeholder: "Paste your link here", autoFocus: true, onKeyUp: onKeyUp })),
        react_1.default.createElement(ConfirmButton, { onConfirm: onUserConfirm }),
        areTokensEnabled && react_1.default.createElement(AddTokenButton, { openTokenSelect: openTokenSelect }),
        href != "" && react_1.default.createElement(RemoveStringLinkButton, { removeLink: onRemoveLink })));
};
exports.LinkEntry = LinkEntry;
var TokenEntry = function (_a) {
    var token = _a.token, confirmToken = _a.confirmToken, removeToken = _a.removeToken;
    var _b = __read((0, react_1.useState)(), 2), tokenMatchedBySearch = _b[0], updateTokenMatchedBySearch = _b[1];
    var onTokenChange = function (selectedToken) {
        if (selectedToken) {
            confirmToken(new Types_1.TokenInput(selectedToken.apiName, selectedToken.name, SubstitutionTokenFactory_1.default.fromLegacyApiToken(selectedToken)));
        }
        else {
            removeToken();
        }
    };
    return (react_1.default.createElement("div", { className: ButtonWidgetLinkMenu_css_1.buttonWidgetLinkMenuStyle },
        react_1.default.createElement(TokenInput_1.default, { type: Types_3.TokenDataType.String, token: token, onTokenChange: onTokenChange, onTokenMatchedBySearch: updateTokenMatchedBySearch }),
        react_1.default.createElement(ConfirmButton, { onConfirm: function () {
                if (tokenMatchedBySearch) {
                    onTokenChange(tokenMatchedBySearch);
                }
                else {
                    confirmToken(token);
                }
            } }),
        react_1.default.createElement(RemoveTokenButton, { removeToken: removeToken })));
};
var ConfirmButton = function (_a) {
    var onConfirm = _a.onConfirm;
    return react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Tick, null), onClick: onConfirm });
};
var RemoveStringLinkButton = function (_a) {
    var removeLink = _a.removeLink;
    return react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Unlink, null), onClick: removeLink });
};
var AddTokenButton = function (_a) {
    var openTokenSelect = _a.openTokenSelect;
    return react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Tokens, null), onClick: openTokenSelect });
};
var RemoveTokenButton = function (_a) {
    var removeToken = _a.removeToken;
    return react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.RemoveToken, null), onClick: removeToken });
};
var initialState = function (href) {
    if (!href || typeof href === "string") {
        return CurrentView.LinkEntry;
    }
    else {
        return CurrentView.TokenEntry;
    }
};
